import * as React from 'react';
import { Grid, Box } from '@moonpig/launchpad-components';
import { BlockItem } from '../BlockItem/BlockItem';
export var BlockLayoutG = function BlockLayoutG(_ref) {
  var items = _ref.items;
  return React.createElement(Grid, {
    gap: true
  }, items.map(function (item, i) {
    return React.createElement(Box, {
      key: i,
      width: {
        xs: 1 / 2,
        md: 1 / 4
      }
    }, React.createElement(BlockItem, item));
  }));
};